import CardModal from '../CardModal';
import useEditCardFormController from '../edit-card-modal/useEditCardFormController';
import EditCardModal from '../edit-card-modal/EditCardModal';

export default function EditCardUsageOptionsReadOnly() {
  useEditCardFormController(() => {});

  return (
    <EditCardModal id="read-only-card-form">
      <CardModal.ProductsAndServices readOnly white/>
    </EditCardModal>
  );
}
